"use client";

import { Layout } from 'antd';
import styles from './Formats.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';
import { AutoScrollCarousel } from '@/shared/ui/AutoScrollCarousel';
import { ImageIcon } from '@/shared/constants/icon';
import { LogoYoutube } from '@/public/assets/logos/LogoYoutube';
import { Spotify } from '@/public/assets/logos/Spotify';
import { YouTubeMusic } from '@/public/assets/logos/YouTubeMusic/YouTubeMusic';
import { Yandex } from '@/public/assets/logos/Yandex';
import { LogoMusicPlayer } from '@/public/assets/logos/LogoMusicPlayer';
import { SoundCloud } from '@/public/assets/logos/SoundCloud';

const { Content } = Layout;

const formatData = [
  {
    id: 1,
    title: 'YouTube',
    icon: <LogoYoutube width={'3.5dvw'} height={'3.5dvw'}/>
  },
  {
    id: 2,
    title: 'Spotify',
    icon: <Spotify width={'3.5dvw'} height={'3.5dvw'}/>
  },
  {
    id: 3,
    title: 'SoundCloud',
    icon: <SoundCloud width={'3.5dvw'} height={'3.5dvw'}/>
  },
  {
    id: 4,
    title: 'YouTube Music',
    icon: <YouTubeMusic width={'3.5dvw'} height={'3.5dvw'}/>
  },
  {
    id: 5,
    title: 'Yandex',
    icon: <Yandex width={'3.5dvw'} height={'3.5dvw'}/>
  },
  {
    id: 6,
    title: 'Any Others',
    icon: <LogoMusicPlayer width={'3.5dvw'} height={'3.5dvw'}/>
  },
];

export const Formats = () => {
  const tKey = 'musicPlayer.formats';
  const t = useTranslations(tKey);

  return (
    <Content className={styles.root}>
      <ScrollReveal>
        <h1>{t('supportedFormats')}</h1>
      </ScrollReveal>

      <AutoScrollCarousel
        data={formatData}
        tKey={tKey}
        isTranslated={false}
      />
    </Content>
  );
};
